import Header from "../../Header";
import { useParams } from "react-router-dom";
import React, { useEffect, useState} from "react";
import { Project, ValidationErrors } from "../../../types/admin";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { AxiosError } from 'axios';
import ProjectComponent from "../../../Components/admin/ProjectComponent";
import { AdminApi } from "../../../Api/AdminApi";
import { useAdmin } from "../../../Utils/AdminContext";

function CreateProject() {
  const { instance, accounts } = useMsal();
  const [ project, setProject] = useState<Project>();
  const [ successMessage, setSuccessMessage ] = useState<string>("");
  const [errors, setErrors] = useState<ValidationErrors>({});
  const api = new AdminApi(accounts[0], instance);
  const navigate = useNavigate();
  
    const { isAdmin, setIsAdmin } = useAdmin();
    useEffect(() => {
      if (isAdmin === false) {
        navigate('/'); 
      }
    }, [isAdmin, navigate]);
  useEffect(() => {
    const newProject: Project = {
        id: "",
        code: null,
        name: null,
        description: null,
        cordaStatus: null,
        questionnaireStatus: null,
        isCbe : false
    }
    setProject(newProject);
  }, []);

  const handleInputChange = (field: keyof Project) => (e: React.ChangeEvent<HTMLInputElement>) => {
    if (project) {
      setProject({
        ...project,
        [field]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
      });
    }
  };

  const handleSubmit = async (project : Project) => {
    setErrors({});
    setSuccessMessage("");
    try{
      var result = await api.createProject(project);
      if (result === "success") {
        setSuccessMessage("Project has been successfully created");
      }
      navigate("/admin/projects")

    }catch(error)
    {
      if (error instanceof AxiosError &&error.response?.status === 400) {
        setErrors(error.response.data.errors);
      }else{
        navigate("/")
      }
    }
  }
  return (
    <>
      <Header projectName="" loaded={false} isAdmin={true}/>
      {project === undefined ? null :<>
        <div className="project-container">
          <ProjectComponent 
            onChange={handleInputChange} 
            handleSubmit={() =>handleSubmit(project)} 
            project={project}
            errors={errors}
            successMessage={successMessage}
            isProjectCreation={true}/>
        </div>
        
        <div className="button-holder mt-5">
          <a className="navlink" href={'/admin/projects' }>
            Back to List
          </a>
        </div></>
      } 
    </>
  );
}

export default CreateProject;